import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const EnvironmentBadge = () => {
	const [environment, setEnvironment] = useState<string | null>(null);

	useEffect(() => {
		const hostname = window.location.hostname;

		// Detect environment based on hostname
		if (hostname === 'localhost' || hostname === '127.0.0.1') {
			setEnvironment('LOCAL: ' + hostname);
		} else if (hostname.includes('test-') || hostname.includes('-test.')) {
			setEnvironment('TEST: ' + hostname.split('.')[0]);
		} else if (hostname.includes('prod-') || hostname.includes('preprod') || hostname.includes('-pre.')) {
			setEnvironment('PRE-PRODUKCJA: PRAWDZIWE DANE! ' + hostname.split('.')[0]);
		} else {
			// Production - nie wyświetlaj badge
			setEnvironment(null);
		}
	}, []);

	if (!environment) return null;

	const getBackgroundColor = () => {
		switch (environment.split(':')[0]) {
			case 'LOCAL':
				return 'rgba(76, 175, 80, 0.95)'; // Zielony - zwiększona opacity dla lepszej widoczności
			case 'TEST':
				return 'rgba(255, 152, 0, 0.95)'; // Pomarańczowy - zwiększona opacity dla lepszej widoczności
			case 'PRE-PRODUKCJA':
				return 'rgba(54, 105, 244, 0.95)'; // Niebieski - zwiększona opacity dla lepszej widoczności
			default:
				return 'rgba(0, 0, 0, 0.9)';
		}
	};

	return (
		<Box
			sx={{
				position: 'fixed',
				top: 10,
				left: '50%',
				transform: 'translateX(-50%)',
				zIndex: 9999,
				backgroundColor: getBackgroundColor(),
				color: 'white',
				padding: '16px 32px',
				borderRadius: '8px',
				fontWeight: 'bold',
				fontSize: '28px',
				boxShadow: '0 4px 16px rgba(0,0,0,0.6), 0 0 0 2px rgba(255,255,255,0.3)',
				pointerEvents: 'none', // Nie przeszkadza w użytkowaniu
				userSelect: 'none',
				textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.5)',
				backdropFilter: 'blur(4px)',
			}}
		>
			<Typography
				variant='h5'
				fontWeight='bold'
				fontSize='28px'
				sx={{
					textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.5)',
					letterSpacing: '0.5px',
				}}
			>
				{environment}
			</Typography>
		</Box>
	);
};

export default EnvironmentBadge;
